import { Box } from '@src/shared/ui';
import React from 'react';

export type GridProp = {
  children?: React.ReactNode;
  className?: string;
  autoRowsHeight?: boolean;
  id?: string;
  ref?: React.Ref<unknown>;
};

export const Grid: React.FC<GridProp> = ({
  children,
  className,
  autoRowsHeight,
  ref,
  id,
}) => {
  return (
    <Box
      id={id}
      ref={ref}
      className={`
          flex
          justify-center
          overflow-clip
          flex-1
          ${className}
        `}
    >
      <Box
        className={`
            ${autoRowsHeight ? '' : 'auto-rows-min'}
            w-full
            grid
            gap-x-8
            gap-y-0
            grid-cols-4
            mx-6

            sm:grid-cols-8
            sm:mx-10

            md:grid-cols-12
            md:mx-20

            xl:max-w-[1472px]

            lg:gap-x-8
          `}
      >
        {children}
      </Box>
    </Box>
  );
};
